export const validateNullOrUndefined = (value: string) => {
    if (value === null || value === undefined) {
        return '';
    }

    if (value.includes('null')) {
        return value.replace('null', '');
    }

    if (value.includes('undefined')) {
        return value.replace('undefined', '');
    }

    return value;
};
